/* eslint-disable react/prefer-stateless-function */
import React from "react";
import PropTypes from "prop-types";
import VertBarChart from "./VertBarChart";

class Body extends React.Component {
  render() {
    const { facultyRace } = this.props.data;
    const [, ...stackCategories] = facultyRace.columns;
    return (
      <div className="body__container">
        <VertBarChart
          data={facultyRace}
          dataKey="university"
          stackCategories={stackCategories}
          yAxisWidth={125}
          includePercent
          xAxisLabel="Number of faculty"
        />
      </div>
    );
  }
}

Body.propTypes = {
  data: PropTypes.shape({
    facultyRace: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default Body;
